import { Box } from '@mui/material';

// ==============================|| HEADER CONTENT - NOTIFICATION ||============================== //

const Notification = () => {
  return <Box sx={{ flexShrink: 0, ml: 0.75 }}></Box>;
};

export default Notification;
